<template>
  <div class="panel">
    <h3>Account access</h3>
    <toggle-control
      v-model="allowImpersonation"
      label="Allow support to access your account"
      :description="'Enabling this option gives support access to your account for troubleshooting purposes.'"
      @input="save"
    />
    <h4>Access logs</h4>
    <access-logs :account-guid="accountGuid" />
  </div>
</template>

<script>
import AccessLogs from '../admin/accounts/AccessLogs'
import { axios } from '@qlik-trial/automations-ui'
import { MessageLevel } from '@qlik-trial/automations-ui'

export default {
  components: { AccessLogs },

  data() {
    return {
      allowImpersonation: this.$store.getters.getUser.account['allow_impersonation'],
    }
  },

  computed: {
    accountGuid() {
      return this.$store.getters.getUser.account.guid
    },

    provider() {
      return window.provider
    },
  },

  methods: {
    save() {
      axios.put(
        '/account',
        { allow_impersonation: this.allowImpersonation },
      ).then(_response => {
        const actionMessage = this.allowImpersonation ? 'enabled' : 'disabled'
        this.flash({ message: `Account access ${actionMessage}`, level: MessageLevel.SUCCESS })
      }).catch(_error => {
        this.allowImpersonation = !this.allowImpersonation
      })
    },
  },
}
</script>
